(() => {
  const drawer = document.getElementById('slideout-ajax-cart');
  if (!drawer) return;
  let opener, previousOverflow;
  drawer.setAttribute('aria-label', 'Your basket');
  drawer.addEventListener('toggle', event => {
    if (event.newState === 'open') {
      opener = document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      drawer.querySelector('[popovertargetaction="hide"]')?.focus();
    } else {
      document.body.style.overflow = previousOverflow || '';
      if (opener?.isConnected && !drawer.contains(opener)) opener.focus();
    }
  });
  drawer.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const items = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea,summary,[tabindex="0"]')].filter(el => el.getClientRects().length);
    if (!items.length) return;
    if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
  });
})();
